import type { RouteModule } from "../dashboard-app/types"

const routeModule: RouteModule = {
  routes: []
}

export default routeModule